import { Link } from "@mui/material";

const Power = () => {
  return (
    <div className="container--blog_post_page_wrapper">
      <section className="container--blog_post">
        <div className="container--post_content">
          <p className="text--post_paragraph">
            Building a team remotely seems like a daunting task. Naturally, we
            are used to working with people face-to-face, and it can be
            difficult to find out how to get the same results from a team that
            works entirely online. You want to ensure that productivity and work
            ethic remains the same without being in the same room as the people
            you work with, but where do you start? This step-by-step guide will
            focus on the practical ways in which you can get great results from
            your remote team.
          </p>
          <h2 className="header header--page_title_h2_left">
            Find your teammates
          </h2>
          <p className="text--post_paragraph">
            You may already have a virtual team, or you may be looking to build
            one in order to get started. If you do not have a team, do not be
            disheartened; there is a simple and easy way of building a great
            team from scratch online!
          </p>
          <p className="text--post_paragraph">
            <Link
              href="https://www.teammateme.com"
              target="_blank"
              rel="noreferrer noopener dofollow"
              aria-label="Visit TeammateMe for virtual team building"
            >
              TeammateMe
            </Link>{" "}
            is the all-in-one solution to virtual team building. It is an online
            platform that makes it easy to find the perfect team members for
            you, based on what kind of teammates you are seeking. Simply invite
            the people you think would be the biggest asset to your team and
            watch it build before your eyes!
          </p>
          <h2 className="header header--page_title_h2_left">
            Create a remote work policy
          </h2>
          <p className="text--post_paragraph">
            Creating a comprehensive work policy is very important for virtual
            teams. Remote work does not have the same natural structure as
            in-office work, so it is up to you to implement rules and policies
            that keep everyone on the same page. This policy can include
            outlines of who reports to whom, working hours, decision rights,
            meeting times, and general expectations. Specifying the
            responsibilities of each team member is essential. Put this together
            in a document and ensure that every member of the team receives it
            and understands it.
          </p>
          <h2 className="header header--page_title_h2_left">
            Pick a productivity tool that everyone uses
          </h2>
          <p className="text--post_paragraph">
            There are so many different applications out there today that will
            contribute to collaboration and productivity within your team.
            However, unless every team member fully understands and is
            comfortable using these tools already then it may not result in the
            productive outcome that you are looking for. The best way forward is
            to use tools that everyone in your team has already been using
            (Google or Microsoft for many companies), meaning that there will be
            a shorter settling period and your virtual team can get straight to
            work.
          </p>
          <h2 className="header header--page_title_h2_left">
            Regular facetime
          </h2>
          <p className="text--post_paragraph">
            Once your virtual team is built with the help of TeammateMe, the
            next step is to think about ensuring effective communication. In a{" "}
            <Link
              href="https://www.microsoft.com/en-us/microsoft-365/blog/2018/04/19/new-survey-explores-the-changing-landscape-of-teamwork/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read a Microsoft survey on the changing landscape of teamwork"
            >
              study done by Microsoft
            </Link>
            , they found that the vast majority of workers favor in-person
            meetings over any other kind.
          </p>
          <p className="text--post_paragraph">
            This evidence suggests that virtual teams can be disadvantaged
            through a lack of face-to-face contact. The best way to combat this
            is through the use of video-calling, which serves to enable
            employees to feel empowered as part of the team and can combat the
            isolation of working remotely.
          </p>
          <p className="text--post_paragraph">
            Studies have found that{" "}
            <Link
              href="http://resources.idgenterprise.com/original/AST-0023059_TheTopFiveBenefitsofVideoConferencing.pdf"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read about the top five benefits of video conferencing"
            >
              80% of communication is based on visual cues
            </Link>
            , so it is unsurprising that companies see enhanced productivity
            when they introduce regular video calling.. To this end, you can use
            Zoom or Skype, but many other apps also enable video calling.
          </p>
          <h2 className="header header--page_title_h2_left">
            Continue to collaborate
          </h2>
          <p className="text--post_paragraph">
            A major feature of the traditional workplace is that real-time
            collaboration is made incredibly easy. Unfortunately, this is
            something that can be hindered in an online team if open channels of
            communication are not sustained. Maintaining collaboration in a
            virtual team takes a small amount of extra effort, but will be
            completely worth it for the finished result.
          </p>
          <p className="text--post_paragraph">
            Rather than having your team work on projects individually and patch
            them together at the very end, encourage the use of a file-sharing
            application such as Google Docs, or the messaging system on
            TeammateMe where they can collaborate, track changes and leave
            comments to ensure that work flows as it would in a physical office.
          </p>
          <p className="text--post_paragraph">
            Overall, it can seem daunting to build a team remotely and it can be
            difficult to know exactly where to begin. Even once you have a team,
            it can be challenging to find ways to improve productivity and
            maintain an effective work environment when you are not sharing
            physical space. Building your virtual team through TeammateMe is an
            important first step, as it allows you to find your perfect team
            members. Ultimately, it is the tool that will get you started.
            Following the rest of the steps featured in this article will enable
            you to build a strong and effective team, develop great
            relationships and create a happy work environment for all.
          </p>
          <hr className="hr--form_break" />
        </div>
      </section>
    </div>
  );
};

export default Power;
